import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { CustomLoader } from '../../../../../components/custom-loader';

export const IcepackFillerFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="icepack-filler-form">
			<Grid.Row className="icepack-filler-form__row">
				<Grid.Column width={6} className="icepack-filler-form__column">
					Название
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="icepack-filler-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

IcepackFillerFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
